import { apiRequest } from '../client'

/**
 * An article's package units (Verkaufseinheiten), synced from webbill
 * (CHG-2026-09-webbill-delivery-import).
 *
 * Read-only from the backoffice: the levels themselves are sync-owned and the server refuses a
 * write without the import header. The one thing a human sets is the base unit, which lives on the
 * product and is changed with `productsApi.update({ baseUnitLevel })`.
 */
export interface ProductPackageUnit {
  /** webbill's own level numbering, 1..3. */
  level: number
  /** Packaging name, e.g. "Karton" or "Tasse". */
  name: string | null
  /** The EAN of this level; the base level's EAN is the product's scan barcode. */
  ean: string | null
  /** Base units contained in one unit of this level; the base level itself is 1. */
  contains: number
  weightKg: string | null
  /** Whether this is the level paydesk scans and counts stock in. */
  base: boolean
}

export interface ProductPackageUnits {
  items: Array<ProductPackageUnit>
  /** Resolved base: the override when it names an existing level, else the smallest unit, else 1. */
  baseLevel: number
  /** The stored override, or null when the rule decides. */
  baseLevelOverride: number | null
}

export const productPackageUnitsApi = {
  get: (sku: string) =>
    apiRequest<ProductPackageUnits>(
      `/api/v0/admin/products/${encodeURIComponent(sku)}/package-units`,
    ),
}
